import type { ICallBackMomentAddEdit } from '../validation/callBackMoment';
import { translateKeyLang } from '../translate/translate';

export function getFormattedFilledInCallBackMoments(callBackMoments: ICallBackMomentAddEdit[]) {
    const filledInCallBackMoments = callBackMoments.filter(
        (callBackMoment) =>
            callBackMoment.isChecked && (callBackMoment.periodOne.startTime || callBackMoment.periodTwo.startTime)
    );
    const formattedMoments: string[] = [];
    for (const moment of filledInCallBackMoments) {
        const validPeriods = [moment.periodOne, moment.periodTwo].filter((period) => !!period.startTime);
        const formattedPeriods = validPeriods.map((period) => `${period.startTime} - ${period.endTime}`).join(' en ');
        const formattedMoment = `${translateKeyLang('nl', `daysEnum.${moment.dayOfWeek}`)} van ${formattedPeriods}`;
        formattedMoments.push(formattedMoment);
    }

    return formattedMoments;
}
